import React from "react";
import { CATEGORIES, STATUSES } from "../../api/ideas";

/**
 * Сегментированный селектор категорий + select статусов + сортировки.
 * Контроллируемый: значения приходят пропсами, изменения наружу.
 */
export default function IdeaCategoryFilter({
  category,
  status,
  sort,
  q,
  onChange,
}) {
  const set = (patch) => onChange({ category, status, sort, q, ...patch });

  return (
    <div className="idz-filters">
      <div className="idz-search">
        <input
          className="idz-input"
          type="search"
          value={q || ""}
          placeholder="Поиск по идеям…"
          onChange={(e) => set({ q: e.target.value })}
        />
      </div>

      <div className="idz-field">
        <label className="idz-label">Категория</label>
        <select
          className="idz-select"
          value={category || ""}
          onChange={(e) => set({ category: e.target.value || null })}
        >
          <option value="">Все</option>
          {CATEGORIES.map((c) => (
            <option key={c.id} value={c.id}>{c.label}</option>
          ))}
        </select>
      </div>

      <div className="idz-field">
        <label className="idz-label">Статус</label>
        <select
          className="idz-select"
          value={status || ""}
          onChange={(e) => set({ status: e.target.value || null })}
        >
          <option value="">Все</option>
          {STATUSES.map((s) => (
            <option key={s.id} value={s.id}>{s.label}</option>
          ))}
        </select>
      </div>

      <div className="idz-field">
        <label className="idz-label">Сортировка</label>
        <div className="idz-segmented">
          {[
            { id: "hot", label: "Горячее" },
            { id: "new", label: "Новые" },
            { id: "top", label: "Лайки" },
            { id: "in_progress", label: "В работе" },
          ].map((s) => (
            <button
              key={s.id}
              type="button"
              className={sort === s.id ? "is-active" : ""}
              onClick={() => set({ sort: s.id })}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
